module.exports = __webpack_public_path__ + "media/images/sp/accessories/dress/dress_01_thumb-28271d67c4d34c918e0e330b80fedab6.jpg";